import { defineMessages } from 'react-intl';

import { LEGAL_DOCUMENT_TYPES } from '@didaskill/domain/legal-document/constants';

export const legalDocumentTypesMessages = defineMessages<LEGAL_DOCUMENT_TYPES>({
  [LEGAL_DOCUMENT_TYPES.SCHOOL_RULES]: {
    defaultMessage: 'Règlement intérieur',
  },

  [LEGAL_DOCUMENT_TYPES.PRIVACY_POLICY]: {
    defaultMessage: 'Politique de confidentialité',
  },
  [LEGAL_DOCUMENT_TYPES.AI_PACT]: {
    defaultMessage: 'Charte IA',
  },
  [LEGAL_DOCUMENT_TYPES.E_COM_PRIVACY_POLICY]: {
    defaultMessage: 'Politique de confidentialité (e-commerce)',
  },
  [LEGAL_DOCUMENT_TYPES.E_COM_SCHOOL_RULES]: {
    defaultMessage: 'Règlement intérieur (e-commerce)',
  },
  [LEGAL_DOCUMENT_TYPES.E_COM_AI_PACT]: {
    defaultMessage: 'Charte IA (e-commerce)',
  },
});
